<mat-form-field [class.mat-form-field-invalid]="!isValid" class="ep-input-form" appearance="outline" [class.mat-form-field-disabled]="isDisabled">
  <input
    matInput
    disableRipple
    [(ngModel)]="value"
    class="input-date"
    [min]="minDate"
    [max]="maxDate"
    [matDatepicker]="datePicker"
    [disabled]="isDisabled"
    readonly
    placeholder="{{ placeholderMessage | translate }}"
    (click)="onDateClick()"
    (dateChange)="onDateClick()"
  />
  <mat-datepicker-toggle matSuffix [for]="datePicker" [disabled]="isDisabled" disableRipple>
    <mat-icon matDatepickerToggleIcon>
      <app-svg-icon src="assets/icons/ep-calendar-icon.svg"></app-svg-icon>
    </mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker #datePicker></mat-datepicker>
</mat-form-field>
<mat-error *ngIf="!isValid" class="ep-text-regular-12 input-field-error-message">{{ errorMessage | translate }}</mat-error>
